import React, { useContext, useEffect, useState } from 'react';

import { Badge, Modal, Popconfirm } from 'antd';

import { RollbackOutlined, StarFilled, CommentOutlined } from '@ant-design/icons';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import SL_Button from '../../components/buttons/Button';
import CustomToolbar from '../../components/grid/CustomToolbar';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import { displayMessage } from '../../services/helper';
import detail_control_grid_columns from './grid_columns/detail_control_grid_columns';
import SectionGrid from './SectionGrid';
import SectionExerciseGrid from './SectionExerciseGrid';
import styles from '../../services/styles';

const { tc2 } = styles

export default function DetailControl(props) {

    const [control, setControl] = useState([])
    const [controlSections, setControlSections] = useState([])
    const [control_data, setControlData] = useState([])
    const [patient, setPatient] = useState(null)
    const [dentist, setDentist] = useState(null)
    const [monitorFromControl, setMonitorFromControl] = useState(null)

    const [haveDataFromApp, setHaveDataFromApp] = useState(false)
    const [mangosFromApp, setMangosFromApp] = useState(0)

    const gridRef = useGridApiRef()

    const {setShowLoading, windowHeight, user, mobile_mode} = useContext(GeneralContext)

    useEffect(() => {
        loadControl()
    }, [])

    async function loadControl() {
        setShowLoading(true)

        await api.dialy_controls.findControl(props.control_id).then(
            rs => {
                setShowLoading(false)
                setControl(
                    rs.data?.DialyHistorics ?
                     rs.data?.DialyHistorics.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                     : []
                )
                setDentist(rs.data?.control?.Dentist)
                setPatient(rs.data?.control?.Patient)
                setControlData(rs.data?.control)
                loadMonitor(rs.data?.DialyHistorics[0]?.monitor_id)
                loadCommentarys(rs.data?.control?.id)
                setControlSections(rs.data?.ControlSections)
                setHaveDataFromApp(rs.data?.haveDataFromApp)
                setMangosFromApp(rs.data?.mangosFromApp)
            }
        ).finally(
            setShowLoading(false)
        )
    }

    async function loadCommentarys(id) {
        try {
            let rs = await api.control.listComments(id)
            props.setCurrentComments(rs.data)

        } catch (error) {
            console.log(error)
        }
    }

    const loadMonitor = async (id) => {
        if (id && id != 1) { //id 1 é o admin então sempre retorna erro quando for uma falta
            let rs = await api.monitor.get(id)
            setMonitorFromControl(rs.data)
        }
    }

    const renderCustomToolBar = () => {
        return (<CustomToolbar />)
    }

    const handleResumeEndedDialy = async (monitor_id, historyControl_array) => {
        setShowLoading(true)
        try {
            let payload = []
            for (let index = 0; index < historyControl_array.length; index++) {
                const historyControl = historyControl_array[index];
                let controlObj = { id: historyControl.dialycontrol_id }
                payload.push(controlObj)
            }
            const rs = await api.dialy_controls.resumeEndedDialy(monitor_id, payload)
            if (rs.status == 200) {
                alert(displayMessage('RESUME_ENDED_MONITORY_SUCCESS'), 'success')
                props.handleOnCloseModal()
            } else {
                alert(rs, 'error')
            }
        } finally {
            setShowLoading(false)
        }
    }
    const handleOpenCommentaryModal = () => {
        props.setIsModalCommentaryVisible(true)
    }

    return (
        <Modal
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            width={750}
            style={{ position: 'relative', marginTop: 50 }}
            bodyStyle={{ maxHeight: windowHeight * 0.9, overflow: 'auto' }}
            footer={<div></div>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 8, }}>
                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                    <div style={{ display: 'flex', flex: 1 }}>
                        <img src={patient?.image_url} style={{ height: 50, width: 50, borderRadius: "50%" }} />

                        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', marginLeft: 15, marginRight: 25, flexDirection: mobile_mode ? 'column' : 'row' }}>
                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', marginBottom: 8, marginTop: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: -6 }}>
                                    <div style={{ marginLeft: 4, fontWeight: 'bold' }}>{patient?.first_name} {patient?.last_name} - </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: -6, marginLeft: 4, marginTop: 0, flex: 1 }}>
                                            <div>
                                                {`${displayMessage('MONITORY')}: ${control_data?.stars ? control_data?.stars : displayMessage('NOT_INFORMED2')} `}
                                            </div>
                                            <StarFilled style={{ marginTop: 6, fontSize: 12 }} />
                                        </div>

                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: -6, marginLeft: 4, marginTop: 0, flex: 1 }}>
                                            <div>
                                                {`${displayMessage('EXERCISE')}: ${control_data?.exercise_stars ? control_data?.exercise_stars : displayMessage('NOT_INFORMED2')} `}
                                            </div>
                                            <StarFilled style={{ marginTop: 6, fontSize: 12 }} />
                                        </div>

                                    </div>
                                </div>
                                <div style={{ marginLeft: 4, fontSize: 12, marginTop: -4 }}>{dentist?.first_name} {dentist?.last_name}</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flex: 1, justifyContent: 'space-evenly', marginTop: mobile_mode ? 10 : '', marginBottom: mobile_mode ? 5 : '' }}>

                        <Badge count={props.currenComments && props?.currenComments?.length} style={{ zIndex: 2, display: 'flex', flex: 1 }}>
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                disabled={!control || !controlSections || props?.currenComments?.length < 1 ? true : false}
                                icon={<CommentOutlined className={`text-base text-${!control || props?.currenComments?.length < 1 ? 'gray' : 'green'}-900`} />}
                                onClick={handleOpenCommentaryModal}
                            >
                                {displayMessage('COMMENTS')}
                            </SL_Button>
                        </Badge>

                        <Popconfirm
                            zIndex={10001}
                            placement="topRight"
                            title={
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div>
                                        {displayMessage('COMFIRMATION_RESUME_ENDED_CONTROL_1', [patient?.first_name, patient?.last_name])}
                                    </div>
                                    <div>
                                        {displayMessage('COMFIRMATION_RESUME_ENDED_CONTROL_2', [monitorFromControl?.first_name, monitorFromControl?.last_name])}
                                    </div>
                                    <div>
                                        {displayMessage('COMFIRMATION_RESUME_ENDED_CONTROL_3')}
                                    </div>
                                </div>
                            }
                            onConfirm={() => {
                                let latestDailyControl = null;
                                let greatestIndex = 0;
                                for (let i = 0; i < control.length; i++) {
                                    let element = control[i];
                                    if (element.id > greatestIndex) {
                                        greatestIndex = element.id;
                                        latestDailyControl = element;
                                    }
                                }
                                handleResumeEndedDialy(user.id, [latestDailyControl])
                            }}
                            okText={displayMessage('YES')}
                            cancelText={displayMessage('NO')}
                        >
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                disabled={control.length >= 1 || control.day_missed < 1 ? false : true} //quando for falta não deve ter o botão de resume
                                icon={<RollbackOutlined className={`text-base text-${control.length >= 1 ? 'green-900' : 'white'}`} />}
                            >
                                {displayMessage('RESUME')}
                            </SL_Button>
                        </Popconfirm>
                    </div>
                </div>

                {controlSections.length > 0 &&
                    controlSections.map(
                        (controlSection, index) => {
                            return (
                                <div style={{ marginBottom: 10 }}>
                                    <SectionGrid section={controlSection} index={index + 1} maxGridCounts={props?.maxControlSection}/>
                                </div>
                            )
                        }
                    )
                }
                <div style={{ marginBottom: 10 }}>
                    <SectionExerciseGrid conrol={control_data}/>
                </div>

                <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'end', alignItems: 'center'}}>
                {
                    haveDataFromApp ?
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', background: tc2, paddingLeft: 5, paddingRight: 5, color: 'white', borderRadius: 7}}>
                            {displayMessage('HAVE_MANGOS_FROM_APP_TAG',[mangosFromApp])}
                        </div>
                    :
                        <></>
                }
                </div>
            </div>
            <div style={{ height: 400 }}>
                <DataGridPro
                    rows={control}
                    apiRef={gridRef}
                    style={{ height: '100%' }}
                    columns={detail_control_grid_columns}
                    pagination
                    pageSize={100}
                    components={{
                        Toolbar: renderCustomToolBar,
                    }}
                    density="compact"
                    disableMultipleSelection
                    disableSelectionOnClick={true}
                />
            </div>
        </Modal >
    )
}

